import { RequestService } from '../../services/RequestService';
import { GET_SERVICE_ADDITIONALS } from '../constants';

export const getServiceAdditionals = payload => {
  return RequestService.get(GET_SERVICE_ADDITIONALS);
};
